import { Path } from "@common/constans";
import Button from "@components/general/form/Button";
import { redirectToLogout } from "@service/Account";
import Translate from "@service/Translate";
import { FC } from "react";
import { useHistory } from "react-router";

export const UserMenu: FC = () => {
    const { tr } = Translate;
    const { push } = useHistory();

    return (
        <div className="user-menu" id="profile">
            <Button
                className="profile-item"
                icon="icon-list1"
                text={tr("my_trips")}
                onClick={() => push(Path.Profile.History)}
            />
            <Button
                className="profile-item"
                icon="icon-account"
                text={tr("profile_account_information")}
                onClick={() => push(Path.Profile.PersonalInformation)}
            />
            <Button
                className="profile-item"
                icon="icon-sign-out"
                text={tr("btn_logout")}
                onClick={redirectToLogout}
            />
            <div className="triangle triangle-up" />
        </div>
    )
}

